const Menu = [
  {
    heading: "menu",
    route: "/association",
    pages: [
      {
        heading: "Entity Tree",
        route: "/entity-organogram/organogramview",
        fontIcon: "bi-dashboard",
        svgIcon: "media/icons/duotune/general/gen019.svg",
      },
      
    ],
  },
];

export default Menu;
